import { render, staticRenderFns } from "./FreeRadio.vue?vue&type=template&id=5b7589ac"
import script from "./FreeRadio.vue?vue&type=script&lang=js"
export * from "./FreeRadio.vue?vue&type=script&lang=js"
import style0 from "./FreeRadio.vue?vue&type=style&index=0&id=5b7589ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports